var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
let order = 1;
const callbackMap = new Map();
const eventMap = new Map();
function kuJiaLeMethodEvent(params) {
  if (params.methodType === "on") {
    const hasEvent = eventMap.get(params.eventType);
    if (hasEvent) {
      const hasCallback = hasEvent.get(params.callback);
      if (hasCallback) {
        return;
      }
    } else {
      eventMap.set(params.eventType, new Map());
    }
    const _order = order++;
    const callback = (event) => {
      if (event.data.action === "Event.on" && event.data._order === _order) {
        params.callback(event.data.value);
      }
    };
    callbackMap.set(params.callback, { order: _order, callback });
    window.addEventListener("message", callback);
    window.parent.postMessage({
      action: "Event.on",
      _order,
      value: [params.eventType]
    });
  }
  if (params.methodType === "off") {
    const hasEvent = eventMap.get(params.eventType);
    if (hasEvent) {
      const offCallback = [];
      if (params.callback) {
        const hasCallback = hasEvent.get(params.callback);
        if (hasCallback) {
          offCallback.push(__spreadValues({}, hasCallback));
        }
      } else {
        hasEvent.forEach((item) => {
          offCallback.push(__spreadValues({}, item));
        });
      }
      offCallback.forEach((item) => {
        hasEvent.delete(item.callback);
        window.removeEventListener("message", item.callback);
        window.parent.postMessage({
          action: "Event.off",
          _order: item.order,
          value: [params.eventType]
        });
      });
    }
  }
  if (params.methodType === "once") {
    const _order = order++;
    const callback = (event) => {
      if (event.data.action === "Event.on" && event.data._order === _order) {
        params.callback(event.data.value);
        window.removeEventListener("message", callback);
      }
    };
    window.addEventListener("message", callback);
    window.parent.postMessage({
      action: "Event.once",
      _order,
      value: [params.eventType]
    });
  }
}
export { kuJiaLeMethodEvent };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/kuJiaLeMethodEvent.js